import { PROFILES } from 'constants/profiles';
import isEmpty from 'helpers/isEmpty';

const listEmails = ['@mobiauto.com.br'];

const isMobiauto = (email, endsWith) => email.endsWith(endsWith);
const defineProfile = email => {
  if (isEmpty(email)) return PROFILES.USER;
  if (listEmails.some(item => isMobiauto(email, item))) {
    return PROFILES.CONSULTOR;
  }
  return PROFILES.USER;
};

export default defineProfile;
